export default __webpack_public_path__ + "static/media/SX.3f08daeb.png";